import { render, staticRenderFns } from "./PrivacityPage.vue?vue&type=template&id=c6bc8516&scoped=true"
import script from "./PrivacityPage.vue?vue&type=script&lang=js"
export * from "./PrivacityPage.vue?vue&type=script&lang=js"
import style0 from "./PrivacityPage.vue?vue&type=style&index=0&id=c6bc8516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bc8516",
  null
  
)

export default component.exports